var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 1.25C15.75 1.25 16 1.5 16 1.75V2.25C16 2.53125 15.75 2.75 15.5 2.75H9V3.5C9 3.78125 8.75 4 8.5 4H7.5C7.21875 4 7 3.78125 7 3.5V2.75H0.5C0.21875 2.75 0 2.53125 0 2.25V1.75C0 1.5 0.21875 1.25 0.5 1.25H7V0.5C7 0.25 7.21875 0 7.5 0H8.5C8.75 0 9 0.25 9 0.5V1.25H15.5ZM15.5 11.25C15.75 11.25 16 11.5 16 11.75V12.25C16 12.5312 15.75 12.75 15.5 12.75H5V13.5C5 13.7812 4.75 14 4.5 14H3.5C3.21875 14 3 13.7812 3 13.5V12.75H0.5C0.21875 12.75 0 12.5312 0 12.25V11.75C0 11.5 0.21875 11.25 0.5 11.25H3V10.5C3 10.25 3.21875 10 3.5 10H4.5C4.75 10 5 10.25 5 10.5V11.25H15.5ZM15.5 6.25C15.75 6.25 16 6.5 16 6.75V7.25C16 7.53125 15.75 7.75 15.5 7.75H13V8.5C13 8.78125 12.75 9 12.5 9H11.5C11.2188 9 11 8.78125 11 8.5V7.75H0.5C0.21875 7.75 0 7.53125 0 7.25V6.75C0 6.5 0.21875 6.25 0.5 6.25H11V5.5C11 5.25 11.2188 5 11.5 5H12.5C12.75 5 13 5.25 13 5.5V6.25H15.5Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.3ff8c712.svg";
export { ForwardRef as ReactComponent };